<template>
    <div>
        <b-modal
            id="modify-Keyword-popup"
            ref="modal"
            :title="titlePopup"
            size="sm"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            :hide-header-close="loading"
            no-close-on-esc
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-3"
                            label="Neutralising Terms"
                            label-for="country-title"
                        >
                            <b-form-input
                                id="neutra_terms-id"
                                v-model="formData.neutra_terms"
                                @input="processInputNeutraWords"
                                type="text"
                                autocomplete="no"
                                placeholder="Enter Neutralising Terms"
                                name="neutra_terms"
                                :class="{
                                    'is-invalid':
                                        errors.has('Neutralising Terms'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12">
                    <b-form-group
                        id="input-group-3"
                        label="Required Terms"
                        label-for="country-title"
                    >
                        <b-form-input
                            id="other_words-id"
                            v-model="formData.other_words"
                            @input="processInputOtherWords"
                            v-validate="{
                                required: false,
                            }"
                            type="text"
                            autocomplete="no"
                            placeholder="Enter Required Terms"
                            name="other_words"
                            :class="{
                                'is-invalid': errors.has('Required Terms'),
                            }"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Update"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),

        titlePopup() {
            //  return 'Modify ThresHold Comparision' + (this.selectedItem ? this.formData.type : '')
            return 'Modify Neutralising and Required Terms '
        }, // End of titlePopup() method
        popupLabel() {
            return (
                (this.selectedItem ? this.formData.type : '') +
                ' Comparision Threshold'
            )
        }, // End of popupLabel() method
        popupPlaceholder() {
            return 'Enter ' + (this.selectedItem ? this.formData.type : '')
        }, // End of popupPlaceholder() method

        // buttonLabel() {
        //     return this.selectedItem ? 'Update' : 'Create'
        // },
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            console.log('value is', value)
            if (value !== null && value !== undefined) {
                console.log('value', Object.assign(this.formData, value))
                Object.assign(this.formData, value)
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        processInputNeutraWords() {
      // Split the input text into an array and remove leading/trailing whitespaces
      this.formData.neutra_terms = this.formData.neutra_terms.replace(/ *, */g, ',').split(',');
    },
        processInputOtherWords() {
      // Split the input text into an array and remove leading/trailing whitespaces
      this.formData.other_words = this.formData.other_words.replace(/ *, */g, ',').split(',');
    },
        initializeFormData() {
            return {
                _id: null,
                id: '',
                neutra_terms: '',
                other_words: '',
                Syntax_tag: null,
                dataSegmentId: null,
                keyword: null,
            }
        }, // End of initializeFormData() method

        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method

        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    // console.log('value is',this.threshold)
                    // this.$emit('click',this.threshold)
                    // this.$refs.modal.hide()
                    this.formData.neutra_terms = this.formData.neutra_terms.filter(term => term !== '');
                    this.formData.other_words = this.formData.other_words.filter(term => term !== '');
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    console.log(error, 'There is an error on submit')
                }
            }
        }, // End of onSubmit() method
    }, // End of Component > watch
}
</script>
